var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { I18nService } from '@app/core';
import { Title } from '@angular/platform-browser';
import { AuthService } from '@app/auth.service';
import { Router, NavigationEnd } from '@angular/router';
import { UserService } from '@app/user.service';
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
import { Observable } from 'rxjs';
var MainmenuComponent = /** @class */ (function () {
    function MainmenuComponent(i18nService, titleService, Auth, router, user, util, apiService) {
        var _this = this;
        this.i18nService = i18nService;
        this.titleService = titleService;
        this.Auth = Auth;
        this.router = router;
        this.user = user;
        this.util = util;
        this.apiService = apiService;
        this.newsList = [];
        this.role = {};
        this.dpa_name = "";
        this.dict = {};
        this.totalSocial = "";
        this.totalChatbot = "";
        router.events.subscribe(function (val) {
            // see also
            if (val instanceof NavigationEnd) {
                _this.InitText(val.url);
            }
        });
    }
    MainmenuComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var thisTs, ck;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        thisTs = this;
                        ck = JSON.parse(localStorage.getItem("dpa_cc"));
                        if (ck == null) {
                            localStorage.setItem("dpa_cc", "{}");
                            this.cookieData = {};
                        }
                        else {
                            this.cookieData = ck;
                        }
                        //document.body.className = 'sidebar-mini accent-danger';
                        //loadTree();
                        //signalr
                        // let notiUrl = await thisTs.apiService.getNotiApiUrl()
                        // const connection = new signalR.HubConnectionBuilder()
                        //   .configureLogging(signalR.LogLevel.Information)
                        //   .withUrl(notiUrl.toString())
                        //   .build();
                        // connection.start().then(function () {
                        //   console.log('Connected!');
                        // }).catch(function (err) {
                        //   return console.error(err.toString());
                        // });
                        // connection.on("BroadcastMessage", (type: string, payload: string) => {
                        //   console.log("type: " + type + ", payload: " + payload)
                        // });
                        //end signal r
                        return [4 /*yield*/, this.getConfig()];
                    case 1:
                        //document.body.className = 'sidebar-mini accent-danger';
                        //loadTree();
                        //signalr
                        // let notiUrl = await thisTs.apiService.getNotiApiUrl()
                        // const connection = new signalR.HubConnectionBuilder()
                        //   .configureLogging(signalR.LogLevel.Information)
                        //   .withUrl(notiUrl.toString())
                        //   .build();
                        // connection.start().then(function () {
                        //   console.log('Connected!');
                        // }).catch(function (err) {
                        //   return console.error(err.toString());
                        // });
                        // connection.on("BroadcastMessage", (type: string, payload: string) => {
                        //   console.log("type: " + type + ", payload: " + payload)
                        // });
                        //end signal r
                        _a.sent();
                        this.dpa_name = this.cookieData.dpa_name;
                        this.getNotiAndNews();
                        this.intervalId = setInterval(function () {
                            thisTs.getNotiAndNews();
                        }, 7000);
                        //let qsParam = "?date_start=" + moment().subtract(1, 'years').format("YYYY-MM-DD") + "&date_end=" + moment().format("YYYY-MM-DD")
                        //this.genNews()
                        //$('[data-provide="datepicker"]').after('<i class="fa fa-calendar" style="color: var(--cust-blue)" aria-hidden="true"></i>');
                        $('[data-provide="datepicker"]').attr('placeholder', 'DD/MM/YYYY');
                        $('.modal').on("hidden.bs.modal", function (e) {
                            if ($('.modal:visible').length) {
                                $('.modal-backdrop').first().css('z-index', parseInt($('.modal:visible').last().css('z-index')) - 10);
                                $('body').addClass('modal-open');
                            }
                        }).on("show.bs.modal", function (e) {
                            if ($('.modal:visible').length) {
                                $('.modal-backdrop.in').first().css('z-index', parseInt($('.modal:visible').last().css('z-index')) + 10);
                                $(this).css('z-index', parseInt($('.modal-backdrop.in').first().css('z-index')) + 10);
                            }
                        });
                        $(".user-menu").on("click", function () {
                            thisTs.router.navigate(["/mainmenu/" + this.id]);
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    MainmenuComponent.prototype.InitText = function (urlpath) {
        var thisTs = this;
        this.cookieData = JSON.parse(localStorage.getItem("dpa_cc"));
        if (this.cookieData != null && this.cookieData.role != null) {
            this.role = JSON.parse(this.cookieData.role);
        }
        setTimeout(function () {
            //clear active tab menu
            thisTs.ClaerActiveTabMenu();
            //--set active menu
            var targetUrlArray = urlpath.split("/");
            if (targetUrlArray.length > 0) {
                var id = targetUrlArray[targetUrlArray.length - 1];
                $("#" + id).prop("aria-selected", true);
                $("#" + id).addClass("active");
                $("#" + id).closest(".menu-container").addClass("menu-container-active");
            }
            //---
        }, 400);
        this.util.InitValidation();
    };
    MainmenuComponent.prototype.setLanguage = function (language) {
        this.i18nService.language = language;
        this.InitLangImage();
    };
    MainmenuComponent.prototype.InitLangImage = function () {
        var image = document.getElementById('imgLang');
        var res = this.i18nService.language.split('-');
        image.src = "assets/dist/img/lang/flags_iso/16/" + res[0] + ".png";
    };
    MainmenuComponent.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                data = this.user.logout();
                if (!data.status) {
                    this.Auth.setLoggedIn(false);
                    this.router.navigate(['login']);
                }
                else {
                    this.util.ErrorDialog("ออกจากระบบไม่สำเร็จ");
                }
                return [2 /*return*/];
            });
        });
    };
    Object.defineProperty(MainmenuComponent.prototype, "languages", {
        get: function () {
            return this.i18nService.supportedLanguages;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainmenuComponent.prototype, "title", {
        get: function () {
            return this.titleService.getTitle();
        },
        enumerable: true,
        configurable: true
    });
    MainmenuComponent.prototype.ClaerActiveTabMenu = function () {
        $(".user-menu").each(function () {
            $(this).prop("aria-selected", false);
            $(this).removeClass("active");
        });
        $(".menu-container-active").each(function () {
            $(this).removeClass("menu-container-active");
            $(this).addClass("menu-container");
        });
    };
    MainmenuComponent.prototype.getConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, crisisConfig;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.apiService.get("master", "configuration")];
                    case 1:
                        _a.config = _b.sent();
                        crisisConfig = this.config.filter(function (c) {
                            return c.dpa_name == "CRISIS FLAG";
                        });
                        if (crisisConfig != null && crisisConfig.length > 0 && crisisConfig[0].dpa_crisisflag == true) {
                            this.cookieData.isCrisis = true;
                            localStorage.setItem("dpa_cc", JSON.stringify(this.cookieData));
                        }
                        else {
                            this.cookieData.isCrisis = false;
                            localStorage.setItem("dpa_cc", JSON.stringify(this.cookieData));
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    MainmenuComponent.prototype.changePassword = function () {
        var url = this.util.baseUrl() + "/changePassword";
        window.open(url, "_blank");
    };
    MainmenuComponent.prototype.genNews = function () {
        return __awaiter(this, void 0, void 0, function () {
            var para, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        para = "dpa_isdisplayoncustomcrmweb=true&dpa_publishstatus=true&dpa_iscrisis=" + this.cookieData.isCrisis.toString();
                        _a = this;
                        return [4 /*yield*/, this.apiService.get("crmservice", "news", para)];
                    case 1:
                        _a.newsList = _b.sent();
                        this.newsList.forEach(function (n) {
                            var news = "<a class=\"text-white mr-5\" target=\"_blank\" href=\"/news/" + n.dpa_newandactivityid + "\">\n          <span class=\"fa fa-newspaper mr-2\"></span>" + n.dpa_name + "\n        </a>";
                            $(".marquee").append(news);
                        });
                        $('.marquee').marquee({
                            duration: 25000,
                            //gap in pixels between the tickers
                            gap: 50,
                            //time in milliseconds before the marquee will start animating
                            delayBeforeStart: 0,
                            //'left' or 'right'
                            direction: 'left',
                            //true or false - should the marquee be duplicated to show an effect of continues flow
                            duplicated: false,
                            pauseOnHover: true
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    MainmenuComponent.prototype.getNotiAndNews = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var para;
            return __generator(this, function (_a) {
                para = "dpa_isdisplayoncustomcrmweb=true&dpa_publishstatus=true&dpa_iscrisis=" + this.cookieData.isCrisis.toString();
                Observable.forkJoin(this.apiService.get("crmservice", "caseIncident", "casechannelcode=04&casestatuscode=01"), this.apiService.get("crmservice", "caseIncident", "casechannelcode=05&casestatuscode=01"), this.apiService.get("crmservice", "news", para)).subscribe(function (data) {
                    if (data[0] != null && data[0].length > 0) {
                        _this.totalSocial = data[0].length.toString();
                    }
                    else {
                        _this.totalSocial = '';
                    }
                    if (data[1] != null && data[1].length > 0) {
                        _this.totalChatbot = data[1].length.toString();
                    }
                    else {
                        _this.totalChatbot = '';
                    }
                    if (_this.isNewsChange(data[2] || [])) {
                        $(".marquee").empty();
                        _this.newsList.forEach(function (n) {
                            var news = "<a class=\"text-white mr-5\" target=\"_blank\" href=\"/news/" + n.dpa_newandactivityid + "\">\n                <span class=\"fa fa-newspaper mr-2\"></span>" + n.dpa_name + "\n              </a>";
                            $(".marquee").append(news);
                        });
                        $('.marquee').marquee({
                            duration: 25000,
                            //gap in pixels between the tickers
                            gap: 50,
                            //time in milliseconds before the marquee will start animating
                            delayBeforeStart: 0,
                            //'left' or 'right'
                            direction: 'left',
                            //true or false - should the marquee be duplicated to show an effect of continues flow
                            duplicated: false,
                            pauseOnHover: true
                        });
                    }
                }, function (err) {
                    console.error(err);
                });
                return [2 /*return*/];
            });
        });
    };
    MainmenuComponent.prototype.isNewsChange = function (responseList) {
        var _this = this;
        var newsListCount = 0;
        var responseCount = 0;
        if (this.newsList != null) {
            newsListCount = this.newsList.length;
        }
        else {
            this.newsList = [];
        }
        if (responseList != null) {
            responseCount = responseList.length;
        }
        else {
            responseList = [];
        }
        if (newsListCount != responseCount) {
            this.newsList = responseList;
            return true;
        }
        responseList.forEach(function (r) {
            if (_this.newsList.indexOf(r) == -1) {
                _this.newsList = responseList;
                return true;
            }
        });
        return false;
    };
    MainmenuComponent.prototype.ngOnDestroy = function () {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    };
    return MainmenuComponent;
}());
export { MainmenuComponent };



// WEBPACK FOOTER //
// ./src/app/mainmenu/mainmenu.component.ts.pre-build-optimizer.js